var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiradisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4686 2.18359H7.70508C7.70508 2.87355 7.97916 3.53526 8.46704 4.02313C8.95492 4.51101 9.61662 4.78509 10.3066 4.78509H11.3686V5.81009C11.369 6.49953 11.643 7.16062 12.1305 7.64813C12.618 8.13564 13.2791 8.4097 13.9686 8.41009V2.68359C13.9686 2.55099 13.9159 2.42381 13.8221 2.33004C13.7284 2.23627 13.6012 2.18359 13.4686 2.18359Z",
    fill: "#DEE2E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6165 5.05469H4.85352C4.85391 5.74413 5.12797 6.40522 5.61548 6.89273C6.10299 7.38023 6.76407 7.65429 7.45352 7.65469H8.51502V8.68319C8.51581 9.37263 8.79025 10.0336 9.27804 10.5208C9.76583 11.008 10.4271 11.2817 11.1165 11.2817V5.55469C11.1165 5.42208 11.0638 5.2949 10.9701 5.20113C10.8763 5.10737 10.7491 5.05469 10.6165 5.05469Z",
    fill: "#CED4DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7635 7.92578H2C1.99993 8.26746 2.06718 8.6058 2.19788 8.92149C2.32859 9.23717 2.52021 9.52402 2.76179 9.76564C3.00336 10.0073 3.29017 10.1989 3.60583 10.3297C3.92149 10.4605 4.25982 10.5278 4.6015 10.5278H5.6665V11.5528C5.6669 12.2417 5.94054 12.9023 6.4274 13.3898C6.91426 13.8772 7.57458 14.1516 8.2635 14.1528V8.42578C8.2635 8.29317 8.21082 8.166 8.11705 8.07223C8.02328 7.97846 7.89611 7.92578 7.7635 7.92578Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiradisable);
export default __webpack_public_path__ + "static/media/jiradisable.f323209af116bec079ee3a242336e7f0.svg";
export { ForwardRef as ReactComponent };